var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lock_svg__a",
    d: "M14.098 7.364a1.634 1.634 0 011.533 1.628v7.173A1.63 1.63 0 0114 17.798l-10.17.006a1.636 1.636 0 01-1.635-1.633V9a1.633 1.633 0 011.631-1.636h10.272zm-8.825-.73H4.79A.634.634 0 014.154 6V4.957A4.763 4.763 0 018.908.196a4.764 4.764 0 014.76 4.755L13.672 6c0 .35-.285.635-.635.635h-.484A.634.634 0 0111.917 6V4.952A3.008 3.008 0 008.91 1.95a3.008 3.008 0 00-3.003 3.006V6c0 .35-.283.635-.634.635z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#lock_svg__a"
  })));
}
export default SvgLock;